import React, { useContext, useEffect } from "react";
import { format } from "date-fns";
import "./classic.css";

import { ResumeContext } from "../../../contexts/resumeContext";
import { iconMap } from "../../../utils/constants";
import { Location, Mail, Phone } from "../../Icons/Icons";

function Classic({ info }) {
  const { setColorOptions, activeColor, setActiveColor, resumeHeadings, setImgSupported } =
    useContext(ResumeContext);

  useEffect(() => {
    setColorOptions(["#5eb9ad", '#ae916f', '#495fa3', '#dcbb62']);
    setActiveColor("#5eb9ad");
    setImgSupported(true)
  }, []);

  const {
    personalDetails,
    educationDetails,
    professionalDetails,
    skills,
    social,
    misc,
  } = info;

  console.log('personalDetails', professionalDetails);

  const education = Object.values(educationDetails || {});
  const work = Object.values(professionalDetails || {});
  const userSkills = Object.values(skills || {});
  const socialLinks = Object.values(social || {});
  const { courses, hobbies, languages, references, internships, activities, projects } =
    misc || {};
  return (
    <div className="classic">
      <div className="classic__header classic__section">
      {personalDetails?.userImage && <img className="classic__userimg" style={{borderColor: activeColor}} src={personalDetails?.userImage} />}
         <div>
          <h1 className="classic__title">
            <span style={{color: activeColor}}>{personalDetails?.firstName?.trim()}</span>{" "}
            {personalDetails?.lastName?.trim()}
          </h1>
          <p className="classic__jobTitle">{personalDetails?.jobTitle}</p>
          {personalDetails?.summary && <div dangerouslySetInnerHTML={{ __html: personalDetails?.summary }} />}
        </div>
      </div>
      <ul className={"classic__contactList"}>
          {personalDetails?.phone && (
            <li>
              <a href={`tel:${personalDetails?.phone?.trim()}`}>
                <Phone style={{color:activeColor}}/>
                {personalDetails?.phone?.trim()}
              </a>
            </li>
          )}
          {(personalDetails?.address?.trim() ||
            personalDetails?.postalCode?.trim()) && (
            <li>
              <Location style={{color:activeColor}}/>
              {personalDetails?.address?.trim()}
              {personalDetails?.postalCode?.trim() && " - "}
              {personalDetails?.postalCode?.trim()}
            </li>
          )}
          {personalDetails?.email && (
            <li>
              <a href={`mailto:${personalDetails?.email?.trim()}`}>
              <Mail style={{color:activeColor}}/>
                {personalDetails?.email?.trim()}
              </a>
            </li>
          )}
          {socialLinks.map((link, ix) =>
            link.link !== "" ? (
              <li>
                <a href={link.link} target="_blank">
                <span style={{color: activeColor}}>{iconMap[link.label?.toLowerCase()] || link.label}</span>
                  {link.link}
                </a>
              </li>
            ) : null
          )}
        </ul>
      <div className="classic__body">
        {!!userSkills?.length && <div className="classic__section">
          <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.SK}</h3>
          <ul className="classic__skills__list">
            {userSkills.map((skill, ix) => (
              <li key={skill + ix} style={{background: activeColor}}>{skill}</li>
            ))}
          </ul>
        </div>}
        {!!work?.length && <div className="classic__section">
          <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.WE}</h3>
          {work.map((exp, ix) => (
            <div className="classic__subsection" key={`exp_${ix}`}>
              <strong>{exp.jobTitle}</strong>
              <p className="classic__subsection_text">
                {exp.company}
                {exp.location && <>, {exp.location}</>}
                <span style={{ float: "right" }}>
                  {exp.startDate && (
                    <>{format(new Date(exp.startDate), "MMM yyyy")}</>
                  )}{" "}
                  {exp.endDate && (
                     <>- {exp.endDate === "Present" ? "Present" : format(new Date(exp.endDate), "MMM yyyy")}</>
                  )}
                </span>
              </p>
              <div
                className="classic__subsection_text"
                dangerouslySetInnerHTML={{ __html: exp.description }}
              />
            </div>
          ))}
        </div>}
        {!!internships?.length && (
          <div className="classic__section">
            <h3
              className="classic__section__heading" style={{color: activeColor}}
            >
              {resumeHeadings?.INT}
            </h3>
            {internships.map((intern, ix) => (
              <div className={"classic__subsection"} key={`intern_${ix}`}>
                <p style={{ marginBottom: 0 }}>
                  <strong>{intern.jobTitle}</strong>
                  <span style={{ float: "right", fontWeight: 400 }}>
                    {intern.startDate && (
                      <>{format(new Date(intern.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {intern.endDate && (
                      <>- {format(new Date(intern.endDate), "MMM yyyy")}</>
                    )}
                  </span>
                </p>
                <p className={"classic__subsection_text"}>
                  {intern.company}
                  {intern.location && <>, {intern.location}</>}
                </p>
                <div
                  className={"classic__subsection_text"}
                  dangerouslySetInnerHTML={{ __html: intern.description }}
                />
              </div>
            ))}
          </div>
        )}
        {!!education?.length && <div className="classic__section">
          <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.AD}</h3>
          {education?.map((ed, ix) => (
            <div className={"classic__subsection"} key={`ed_${ix}`}>
              <strong>{ed.degree}</strong>
              <p className={"classic__subsection_text"}>
                {ed.institute}
                {ed.location && <>, {ed.location}</>}
                <span style={{ float: "right" }}>
                  {ed.startDate && (
                    <>{format(new Date(ed.startDate), "MMM yyyy")}</>
                  )}{" "}
                  {ed.endDate && (
                    <>- {format(new Date(ed.endDate), "MMM yyyy")}</>
                  )}
                </span>
              </p>
              <div
                className={"classic__subsection_text"}
                dangerouslySetInnerHTML={{ __html: ed.description }}
              />
            </div>
          ))}
        </div>}
        {!!projects?.length && <div className="classic__section">
          <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.PRO}</h3>
          {projects?.map((pro, ix) => (
            <div className={"classic__subsection"} key={`pro_${ix}`}>
              <strong>{pro.title}</strong>
              <p className={"classic__subsection_text"}>
                {pro.company}
                <span style={{ float: "right" }}>
                  {pro.startDate && (
                    <>{format(new Date(pro.startDate), "MMM yyyy")}</>
                  )}{" "}
                  {pro.endDate && (
                    <>- {format(new Date(pro.endDate), "MMM yyyy")}</>
                  )}
                </span>
              </p>
              <div
                className={"classic__subsection_text"}
                dangerouslySetInnerHTML={{ __html: pro.description }}
              />
            </div>
          ))}
        </div>}
        {!!courses?.length && (
          <div className={"classic__section"}>
            <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.CR}</h3>
            {courses?.map((course, ix) => (
              <div className={"classic__subsection"} key={`course_${ix}`}>
                <strong>{course.name}</strong>
                <p className={"classic__subsection_text"}>
                  {course.institution}{" "}
                  <span style={{ float: "right" }}>
                    {course.startDate && (
                      <>{format(new Date(course.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {course.endDate && (
                      <>- {format(new Date(course.endDate), "MMM yyyy")}</>
                    )}
                  </span>
                </p>
              </div>
            ))}
          </div>
        )}
        {!!activities?.length && (
          <div className="classic__section">
            <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.ACT}</h3>
            {activities.map((activity, ix) => (
              <div className={"classic__subsection"} key={`activity_${ix}`}>
                <strong>{activity.title}</strong>
                <p className={"classic__subsection_text"}>
                  {activity.institution}
                  <span style={{ float: "right" }}>
                    {activity.startDate && (
                      <>{format(new Date(activity.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {activity.endDate && (
                      <>- {format(new Date(activity.endDate), "MMM yyyy")}</>
                    )}
                  </span>
                </p>
                <div
                  className={"classic__subsection_text"}
                  dangerouslySetInnerHTML={{ __html: activity.description }}
                />
              </div>
            ))}
          </div>
        )}
        {!!hobbies?.length && (
          <div className="classic__section">
            <div className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.HOB}</div>
            <p className={"classic__subsection_text"}>{hobbies}</p>
          </div>
        )}
        {!!languages?.length && (
          <div className="classic__section">
            <div className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.LAN}</div>
            <p className={"classic__subsection_text"}>{languages}</p>
          </div>
        )}
        {!!references?.length && (
          <div className="classic__section">
            <h3 className="classic__section__heading" style={{color: activeColor}}>{resumeHeadings?.REF}</h3>
            {references?.map((ref, ix) => (
              <div className="classic__subsection" key={`ref_${ix}`}>
                <strong>
                  {ref.name}</strong> {ref.institution && <>from <strong>{ref.institution}</strong></>}
                
                <p className="classic__subsection_text">
                  {ref.email} {ref.phone && <> &nbsp; | &nbsp; {ref.phone}</>}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Classic;
